import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const forceCancelUnitActivation = async (id: number): Promise<IActivationServiceRequestModel> =>
  axios.delete(`/management/UnitActivation/ForceCancelUnitActivationById?id=${id}`).then((res) => res?.data?.data)

type Props = {
  id: number
}

export const useManagementForceCancelUnitActivation = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestModel) => void) =>
  useMutation({
    mutationKey: ['forceCancelUnitActivation'],
    mutationFn: ({ id }: Props) => forceCancelUnitActivation(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Force cancelled activation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to force cancel activation.')
      }
    },
    throwOnError: false
  })
